<template lang="pug">
  v-dialog.grey(v-model="fixdialog" scrollable max-width="400")
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ translations.title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container.pa-0(fluid)
          v-row
            v-col(cols="12")
              p.ma-0 {{ translations.text }}
              p.ma-0.mt-6.headline.text-center {{ timeoutMinutes }}:{{ timeoutSeconds|completeZero(2) }}
          v-row
            v-col(cols="12").pa-0.pt-4
              .d-flex.justify-center
                v-btn(@click="refreshToken" color="primary") {{ translations.button.refresh }}

</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: "TokenDialog",
    data:() => ({
      dialog: false,
      warningTime: 48 * 60,
      logoutTime: 2 * 60,   // ver initClock, el tiempo no debe ser menor a 1 minuto
      warningTimerId: null,
      logoutTimerId: null,
      timeoutTimerId: null,
      timeoutMinutes: 0,
      timeoutSeconds: 0,
    }),
    computed: {
      ...mapGetters(['getWarningTime']),
      translations(){
        return this.$t("components.token");
      },
      fixdialog(){
        if(this.$route.path === '/') {
          return false
        }
        return this.dialog
      },
    },
    watch: {
      getWarningTime: function(val){
        if (val == 100){
          this.$store.dispatch('resetWarningTime');
        }
        this.setWarningTime();
      },
    },
    mounted(){
      this.$store.watch((state)=>state.login.token, (newToken)=>{
        if(newToken != ''){
          this.setWarningTime();
        } else if (this.$route.name != 'Login') {
          this.logout();
        }
      })
    },
    methods:{
      setWarningTime(){
        if(this.warningTimerId != null){  // actualizando timer
          clearTimeout(this.warningTimerId);
        }
        this.warningTimerId = setTimeout(this.openDialog, this.warningTime * 1000);
      },
      openDialog(){
        this.dialog = true;
        this.logoutTimerId = setTimeout(this.logout, this.logoutTime * 1000);
        this.initClock();
      },
      logout(){
        clearTimeout(this.warningTimerId);
        clearTimeout(this.logoutTimerId);
        this.clearClock();
        this.warningTimerId = null;
        this.logoutTimerId = null;
        this.dialog = false;
        this.$nextTick(function () {
          this.$store.dispatch('userLogout');
        })
      },
      refreshToken(){
        clearTimeout(this.logoutTimerId);
        this.$store.dispatch('refreshToken');
        this.setWarningTime();
        this.dialog = false;
      },
      initClock(){
        this.timeoutMinutes = this.logoutTime / 60;
        this.timeoutTimerId = setInterval(this.updateClock, 1000);
      },
      clearClock(){
        clearInterval(this.timeoutTimerId);
      },
      updateClock(){
        if(this.timeoutSeconds === 0){
          this.timeoutSeconds = 59;
          this.timeoutMinutes -= 1;
        } else {
          this.timeoutSeconds -= 1;
        }
      }
    },
  }
</script>

<style lang="sass">
</style>